import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  HelpCircle,
  ChevronDown,
  ChevronUp,
  ArrowRight,
  LogIn,
  Phone,
  Mail,
  MessageSquareText,
  CheckCircle2,
} from 'lucide-react';

const FAQS = [
  {
    q: 'سامانه هوشمند کریدور جنوب-شمال چیست؟',
    a: 'این سامانه یک درگاه یکپارچه برای مدیریت لجستیک، حمل‌ونقل ترکیبی و دسترسی به خدمات و فرصت‌های مرتبط در مسیر راهبردی جنوب به شمال است.'
  },
  {
    q: 'چگونه می‌توانم وضعیت محموله خود را رهگیری کنم؟',
    a: 'پس از ورود به پنل کاربری، در بخش «رهگیری محموله» با وارد کردن شماره بارنامه/کد رهگیری، آخرین وضعیت و مراحل انجام‌شده را مشاهده می‌کنید.'
  },
  {
    q: 'برای ثبت درخواست حمل چه اطلاعاتی لازم است؟',
    a: 'اطلاعات پایه مانند مبدا و مقصد، نوع کالا، وزن/حجم، زمان‌بندی، نوع وسیله حمل و مدارک مرتبط (در صورت نیاز) برای ثبت درخواست کافی است.'
  },
  {
    q: 'بارنامه و کد رهگیری را از کجا دریافت کنم؟',
    a: 'پس از نهایی شدن ثبت سفارش یا تایید حمل توسط اپراتور، بارنامه صادر و کد رهگیری در پنل کاربری و اعلان‌های سامانه نمایش داده می‌شود.'
  },
  {
    q: 'آیا امکان مشاهده سوابق حمل و اسناد قبلی وجود دارد؟',
    a: 'بله. در پنل کاربری می‌توانید سوابق سفارش‌ها، وضعیت‌ها، صورتحساب‌ها و فایل‌های مرتبط (در صورت بارگذاری) را مشاهده و دانلود کنید.'
  },
  {
    q: 'تعرفه‌ها چگونه محاسبه می‌شوند؟',
    a: 'تعرفه با توجه به مسیر، نوع حمل، وزن/حجم، نوع کالا، خدمات اضافی (بیمه/انبارداری/بسته‌بندی) و زمان‌بندی محاسبه می‌شود.'
  },
  {
    q: 'در صورت تأخیر یا تغییر مسیر چه اتفاقی می‌افتد؟',
    a: 'در صورت بروز تأخیر یا تغییر در برنامه حمل، وضعیت سفارش در سامانه به‌روزرسانی شده و از طریق پنل و اعلان‌ها اطلاع‌رسانی می‌شود.'
  },
  {
    q: 'آیا امکان بیمه کردن محموله وجود دارد؟',
    a: 'بله. هنگام ثبت سفارش می‌توانید گزینه بیمه را انتخاب کنید یا درخواست بیمه را به پشتیبانی اعلام نمایید تا شرایط و پوشش‌ها ارائه شود.'
  },
  {
    q: 'خدمات گمرکی و ترخیص هم پوشش داده می‌شود؟',
    a: 'در برخی مسیرها و بسته‌های خدماتی، امکان هماهنگی امور گمرکی/ترخیص وجود دارد. جزئیات بر اساس نوع کالا و مرز/گمرک مقصد اعلام می‌شود.'
  },
  {
    q: 'در صورت فراموشی رمز عبور یا مشکل در ورود چه کنم؟',
    a: 'ابتدا از درست بودن نام کاربری و رمز عبور مطمئن شوید. در صورت تداوم مشکل، با پشتیبانی تماس بگیرید تا حساب شما بررسی و بازیابی شود.'
  }
];

export default function FAQ() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="min-h-screen bg-[#f8fafc] font-[IRANSansWeb,Tahoma] p-6 md:p-10" dir="rtl">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Hero */}
        <header className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm p-8 md:p-10 overflow-hidden relative">
          <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_top,rgba(33,57,112,0.10),transparent_70%)]" />
          <div className="relative flex items-start justify-between gap-6">
            <div className="text-right">
              <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-2xl text-[11px] font-extrabold border border-blue-100">
                <HelpCircle size={16} />
                <span>راهنمای کاربران کریدور</span>
              </div>

              <h1 className="mt-6 text-3xl md:text-4xl font-black text-[#1A3062] leading-tight">
                سوالات متداول
              </h1>

              <p className="mt-4 text-sm text-gray-500 leading-8 max-w-2xl">
                هر آنچه درباره سامانه هوشمند کریدور جنوب-شمال می‌خواهید بدانید؛ از ثبت‌نام و ورود تا رهگیری محموله،
                تعرفه‌ها و خدمات گمرکی. روی هر پرسش بزنید تا پاسخ آن نمایش داده شود.
              </p>

              <div className="mt-8">
                <Link
                  to="/"
                  className="h-12 px-5 rounded-2xl border border-gray-200 bg-white hover:bg-gray-50 text-gray-600 font-bold text-sm transition inline-flex items-center justify-center gap-2"
                >
                  <ArrowRight size={18} />
                  بازگشت به صفحه ورود
                </Link>
              </div>
            </div>

            <div className="hidden md:flex w-16 h-16 rounded-2xl bg-blue-50 border border-blue-100 items-center justify-center text-blue-700 flex-shrink-0">
              <MessageSquareText size={28} />
            </div>
          </div>
        </header>

        {/* FAQ list */}
        <section className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm p-4 md:p-6">
          <div className="space-y-3">
            {FAQS.map((faq, idx) => {
              const isOpen = openFaq === idx;
              return (
                <div
                  key={idx}
                  className={`rounded-2xl border transition ${
                    isOpen ? 'border-blue-100 bg-[#f7faff]' : 'border-gray-100 bg-[#fbfdff] hover:shadow-sm'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenFaq(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between gap-4 text-right p-5"
                    aria-expanded={isOpen}
                  >
                    <span className="flex items-center gap-3 min-w-0">
                      <span className="w-9 h-9 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center text-blue-700 text-xs font-black flex-shrink-0">
                        {(idx + 1).toLocaleString('fa-IR')}
                      </span>
                      <span className="text-sm font-extrabold text-gray-800 leading-relaxed">{faq.q}</span>
                    </span>
                    <span className={`flex-shrink-0 ${isOpen ? 'text-blue-700' : 'text-gray-400'}`}>
                      {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                    </span>
                  </button>

                  {isOpen && (
                    <div className="px-5 pb-5 pr-[4.5rem]">
                      <p className="text-[12px] text-gray-500 leading-8">{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>

        {/* Support CTA */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 bg-[#1A3062] rounded-[2.5rem] p-8 text-white shadow-xl overflow-hidden relative">
            <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.18),transparent_70%)]" />
            <div className="relative">
              <div className="flex items-center gap-2">
                <CheckCircle2 size={18} className="text-green-400" />
                <h3 className="text-lg font-black">پاسخ سوال خود را پیدا نکردید؟</h3>
              </div>
              <p className="text-[11px] text-blue-200 mt-3 leading-7">
                تیم پشتیبانی کریدور آماده پاسخگویی است. در ساعات کاری با شماره یا ایمیل زیر در ارتباط باشید.
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-2xl p-4">
                  <Phone size={18} className="text-blue-200" />
                  <span className="text-sm font-bold">۰۲۱-۰۰۰۰۰۰۰۰</span>
                </div>
                <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-2xl p-4">
                  <Mail size={18} className="text-blue-200" />
                  <span className="text-sm font-bold">support@corridor.ir</span>
                </div>
              </div>

              <div className="mt-4 text-[10px] text-blue-200 font-bold">
                ساعات پاسخگویی: شنبه تا چهارشنبه، ۹ تا ۱۷
              </div>
            </div>
          </div>

          <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm p-8 flex flex-col justify-between">
            <div className="text-right">
              <h3 className="text-lg font-black text-gray-800">می‌خواهید شروع کنید؟</h3>
              <p className="text-[11px] text-gray-400 mt-2 leading-7">
                برای استفاده از خدمات کریدور وارد پنل کاربری شوید یا ثبت‌نام کنید.
              </p>
            </div>
            <Link
              to="/"
              className="mt-6 h-12 px-5 rounded-2xl bg-[#213970] hover:bg-[#1A3062] text-white font-bold text-sm transition inline-flex items-center justify-center gap-2 shadow-lg shadow-blue-900/15"
            >
              <LogIn size={18} />
              ورود / ثبت‌نام
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
